import { stringify } from 'query-string';

import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'DEMO_REPORT_GET',
  GET_SUCCESS: 'DEMO_REPORT_GET_SUCCESS',
  GET_FAILURE: 'DEMO_REPORT_GET_FAILURE',
  INVALIDATE_ITEM: 'DEMO_REPORT_INVALIDATE_ITEM',
};

export const get = actions.get(
  (studentClassroomId, query) =>
    `${BASE_URL}/student-classrooms/${studentClassroomId}/demo-feedback?${stringify(
      query,
    )}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};
